import React from 'react';
import { Youtube, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-background py-12 px-6" data-id="element-30">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-31">
        <div className="text-center md:text-left" data-id="element-32">
          <p className="font-serif text-xl font-medium mb-2" data-id="element-33">PampaNation</p>
          <p className="text-gray-500 text-sm" data-id="element-34">
            Rock argentino 80/90 en vivo, de cerca.
          </p>
        </div>

        <div className="flex items-center gap-4" data-id="element-35">
          <a href="https://www.youtube.com/@PampaNation" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-gray-400 hover:text-amber-400 hover:bg-surfaceHover transition-colors" aria-label="YouTube" data-id="element-36">
            <Youtube className="w-5 h-5" data-id="element-37" />
          </a>
          <a href="https://www.instagram.com/pampanation" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-gray-400 hover:text-amber-400 hover:bg-surfaceHover transition-colors" aria-label="Instagram" data-id="element-38">
            <Instagram className="w-5 h-5" data-id="element-39" />
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-white/5 text-center text-xs text-gray-600" data-id="element-40">
        <p data-id="element-41">
          &copy; {new Date().getFullYear()} PampaNation. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}